// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable */
import Vue from 'vue'
import store from './store'
import 'normalize.css/normalize.css'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import elementUIVerify from 'element-ui-verify'
// import VXETable from 'vxe-table'
// import 'vxe-table/lib/index.css'
import 'vxe-table-plugin-element/dist/style.css'
import './plugins/utils'
import './plugins/table'
import App from './App'
import router from './router'
import layer from 'vue-layer'
import {routes} from './router'
// import echarts from 'echarts'
import './permission'

// import global css
import '@/styles/index.scss'
import '@/styles/element.scss'
import '@/styles/search.scss'
import '@/styles/view.scss'

// Vue global Component
import '@/components/core'

// import '@/assets/css/libary/font-awesome-4.7.0/css/font-awesome.css'

import pluginExport from '@/plugin/export'

import pluginImport from '@/plugin/import'

// Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
console.log(process.env.NODE_ENV)
Vue.use(pluginExport)
Vue.use(pluginImport)
Vue.use(Element)
Vue.use(elementUIVerify, {
  errorMessageTemplate: {
    empty: '{alias}不能为空',
    length: '请输入{length}位字符',
    minLength: '输入内容至少{minLength}位',
    number: '请输入数字',
    int: '请输入整数',
    lt: '输入数字应小于{lt}',
    lte: '输入数字不能大于{lte}',
    gt: '输入数字应大于{gt}',
    gte: '输入数字不能小于{gte}',
    maxDecimalLength: '该输入项最多接受{maxDecimalLength}位小数',
    phone: '请输入正确的手机号',
    email: '请输入正确的邮箱',
    verifyCode: '请输入正确的验证码'
  }
})
const intRuleGetter = elementUIVerify.getRule('int')
elementUIVerify.addRule('strlength', (length) => [
  intRuleGetter(),
  {
    validator(rule, val, callback) {
     if (val.length > length) {
      callback(Error(`内容不能超过${length}个字符`))
     }
     callback()
    },
  },
])
elementUIVerify.addRule('scoreVerify', (length) => [
  intRuleGetter(),
  {
    validator(rule, val, callback) {
      console.log(22)
     if (isNaN(val)) {
      callback(Error('请输入数字'))
     }
     if (!(+val >= 0 && +val <= 100)) {
      callback(Error('履约分值必须在0-100之间(包含0和100)'))
     }
    
     callback()
    },
  },
])

function delcommafy(num){
  var num = num.replace(/,/gi,'')
  return num
}
elementUIVerify.addRule('comdifyValdate', (length) => [
  intRuleGetter(),
  {
    validator(rule, val, callback) {
     var reg = /^[0-9]+.?[0-9]*$/
     val = delcommafy(val)
     if (!(reg.test(val))) {
      callback(Error('请输入数字'))
     } else {
      if (delcommafy(val) < 0) {
        callback(Error('数值不能小于0'))
      }
     }
     callback()
    },
  },
])
// Vue.use(XEUtils)
// Vue.use(VXETable)
Vue.prototype.$layer = layer(Vue)
Vue.prototype.$dev = process.env.NODE_ENV
/* eslint-disable no-new */
//
// // 创建一个复杂的渲染器（仅用于简单示例，实际开发中应该封装成一个组件，不应该把复杂的渲染逻辑写在渲染器中）

// VXETable.renderer.add('MyComplexFilter', {
//   // 筛选模板
//   renderFilter (h, filterRender, params, context) {
//     let { column } = params
//     return column.filters.map(item => {
//       return <input
//       type="text"
//       value={ item.data }
//       onInput={ evnt => {
//         item.data = evnt.target.value
//         let checked = !!item.data
//         context.changeOption(evnt, checked, item)
//       } }/>
//     })
//   },
//   // 筛选方法
//   filterMethod ({ option, row, column }) {
//     let { data } = option
//     let cellValue = XEUtils.get(row, column.property)
//     /* eslint-disable eqeqeq */
//     return cellValue.indexOf(data) > -1
//   }
// })
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  mounted () {
    //this.getAllPageRoutes()
    //this.$store.commit('SUCCESS_LOAD')
  },
  methods: {
    getAllPageRoutes () {
      let pool = []
      const push = function (routes) {
        routes.forEach(value => {
          if (value.children) {
            push(value.children)
          } else {
            const { meta, name, path } = value
            if (path === '/login') {
            } else {
              pool.push({ meta, name, path })
            }
          }
        })
      }
      push(routes)
      this.$store.commit('POOL_SET', pool)
    }
  }
}).$mount('#app')
